import React from "react";
import { bool, shape, string, oneOf } from "prop-types";
import Gravatar from "react-gravatar";
import { Link } from "react-router-dom";
import cx from "classnames";

function Avatar({ user, size, linkSettings }) {
    if (user) {
        const userParsed = user.userFullName.split(" ");
        const initials =
            (user && user.userFullName.match(/[A-Z]/g)?.join("")) ||
            `${userParsed[0][0]}${userParsed[userParsed.length - 1][0]}`.toLocaleUpperCase();

        const userInitials = initials && initials.substring(0, 2);

        const AvatarFC = linkSettings ? Link : "div";

        let content = null;
        if (!userInitials && user.email) {
            content = (
                <figure>
                    <Gravatar
                        alt={user.userFullName}
                        email={user.email}
                        default="404"
                        onError={() => userInitials}
                        className="rounder-content"
                    />
                </figure>
            );
        }

        return (
            <AvatarFC
                {...(linkSettings && { to: "/settings" })}
                className={cx("avatar", { "avatar-big": size === "big" })}>
                <span className="visually-hidden">{user.userFullName}</span>
                {content}
                <span className="avatar-text" aria-hidden>
                    {userInitials}
                </span>
            </AvatarFC>
        );
    }
    return null;
}

Avatar.propTypes = {
    linkSettings: bool,
    size: oneOf(["normal", "big"]),
    user: shape({
        userFullName: string.isRequired,
        defaultAvatarId: string.isRequired,
    }).isRequired,
};

Avatar.defaultProps = {
    linkSettings: false,
    size: "normal",
};

export default Avatar;
